import { initialRegistry, type Registry } from '@/stores/registry';

export const fieldsFromSaved = (saved: Record<string, unknown>): Partial<Registry> => {
  const result: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(saved)) {
    if (value !== null) {
      result[key] = value;
      continue;
    }

    const fallback = (initialRegistry as Record<string, unknown>)[key];

    if (fallback === undefined) {
      continue;
    }

    result[key] = fallback;
  }

  return result as Partial<Registry>;
};
